export default [
  {
    path: '/book-call',
    name: 'book-call',
    component: () => import('@/views/booking/BookCall.vue'),
    meta: {
      protected: true,
      pageTitle: 'Book Call',
      bookingType: 'normal',
      breadcrumb: [
        {
          text: 'Book Call',
          active: true,
        },
      ],
    },
  },
  {
    path: '/book-call-offsite',
    name: 'book-call-offsite',
    component: () => import('@/views/booking/BookCall.vue'),
    meta: {
      protected: true,
      pageTitle: 'Book Call',
      bookingType: 'offsite',
      breadcrumb: [
        {
          text: 'Book Call',
          active: true,
        },
      ],
    },
  },
  {
    path: '/book-intake-call',
    name: 'book-intake-call',
    component: () => import('@/views/booking/BookCall.vue'),
    meta: {
      protected: true,
      pageTitle: 'Book Call',
      bookingType: 'intake',
      breadcrumb: [
        {
          text: 'Book Call',
          active: true,
        },
      ],
    },
  },
  {
    path: '/booking-slots',
    name: 'booking-slots',
    component: () => import('@/views/booking-slots/BookingSlots'),
    meta: {
      protected: true,
      pageTitle: 'Booking slots',
      offsite: false,
      breadcrumb: [
        {
          text: 'Booking slots',
          active: true,
        },
      ],
    },
  },
  {
    name: 'create-booking-slot',
    path: '/booking-slots/create',
    meta: {
      protected: true,
    },
    component: () => import('@/views/booking-slots/CreateBookingSlot'),
  },
  {
    name: 'update-booking-slot',
    path: '/booking-slots/:bookingSlotId/update',
    meta: {
      protected: true,
    },
    component: () => import('@/views/booking-slots/UpdateBookingSlot'),
  },
  {
    name: 'restricted-booking-dates',
    path: '/restricted-booking-dates',
    meta: {
      protected: true,
    },
    component: () => import('@/views/RestrictedBookingDates/RestrictedBookingDates'),
  },
  {
    name: 'restricted-social-booking-dates',
    path: '/restricted-social-booking-dates',
    meta: {
      protected: true,
    },
    component: () => import('@/views/restrictedSocialBookingDates/RestrictedSocialBookingDates.vue'),
  },
]
